<template>
	<v-dialog :value="value" max-width="520" @input="$emit('input', $event)">
		<v-card>
			<v-card-title class="text-h6">{{ title }}</v-card-title>
			<v-card-text>
				<div v-if="loading" class="text-center py-4">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</div>
				<template v-else-if="estimate">
					<p class="mb-2">
						Verranno analizzati <strong>{{ estimate.total }}</strong> prodotti seguiti: {{ intro }}
					</p>
					<p class="mb-2">
						Tempo stimato: <strong>{{ duration(estimate.estimated_ms) }}</strong>{{ estimate.calls ? ` (${estimate.calls} chiamate)` : '' }}. {{ pace }} L'analisi non è immediata:
						parte in coda e prosegue anche se chiudi la pagina.
					</p>
					<v-alert v-if="estimate.capped" type="warning" text dense class="mb-2">
						Per non esaurire il limite giornaliero di eBay si analizzano al massimo {{ estimate.maxCalls }} prodotti per volta (su {{ estimate.eligible }}): prima quelli cercati meno di recente. Rilancia per i successivi.
					</v-alert>
					<v-alert v-if="estimate.withoutEan > 0" type="info" text dense class="mb-2">
						{{ estimate.withoutEan }} prodotti seguiti non hanno l'EAN e non possono essere confrontati.
					</v-alert>
					<v-alert v-if="estimate.ahead > 0" type="warning" text dense class="mb-2">
						Ci sono già {{ estimate.ahead }} analisi in coda: la tua partirà quando saranno finite.
					</v-alert>
					<v-alert type="info" text dense class="mb-0">Riceverai una notifica alla fine; nel frattempo la pagina mostra l'avanzamento e le righe si aggiornano man mano.</v-alert>
				</template>
				<v-alert v-else type="error" text dense class="mb-0">Impossibile calcolare la stima: riprova.</v-alert>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="$emit('input', false)">Annulla</v-btn>
				<v-btn color="primary" :disabled="loading || !estimate || estimate.total === 0" @click="$emit('confirm')">Avvia analisi</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
// Avviso prima di lanciare: l'analisi dura minuti e va in coda, non e' in tempo reale.
export default {
	name: 'AnalysisConfirmDialog',
	props: {
		value: { type: Boolean, default: false },
		loading: { type: Boolean, default: false },
		// { total, estimated_ms, ahead } (+ eBay: calls, capped, eligible, maxCalls, withoutEan)
		estimate: { type: Object, default: null },
		// cosa si legge per ogni prodotto e perche' ci vuole tempo: cambia per piattaforma
		intro: { type: String, default: 'per ognuno si leggono da Amazon la buybox e la nostra offerta (prezzo + spedizione).' },
		pace: { type: String, default: 'Amazon permette una richiesta ogni 2 secondi circa.' },
		title: { type: String, default: 'Effettua analisi' },
	},
	methods: {
		duration(ms) {
			const seconds = Math.max(1, Math.round((Number(ms) || 0) / 1000));
			if (seconds < 60) {
				return 'meno di un minuto';
			}
			const minutes = Math.ceil(seconds / 60);
			if (minutes < 60) {
				return `circa ${minutes} minut${minutes === 1 ? 'o' : 'i'}`;
			}
			const hours = Math.floor(minutes / 60);
			const rest = minutes % 60;
			return `circa ${hours} or${hours === 1 ? 'a' : 'e'}${rest ? ` e ${rest} minuti` : ''}`;
		},
	},
};
</script>
